/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Not_Found_BodyInputs */

const cs_error_not_found_body = /** @type {(inputs: Error_Not_Found_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tato adresa v Cerebrio není. Zkontrolujte odkaz, nebo se vraťte na přehled.`)
};

const en_error_not_found_body = /** @type {(inputs: Error_Not_Found_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This address is not in Cerebrio. Check the link, or go back to the dashboard.`)
};

/**
* | output |
* | --- |
* | "This address is not in Cerebrio. Check the link, or go back to the dashboard." |
*
* @param {Error_Not_Found_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const error_not_found_body = /** @type {((inputs?: Error_Not_Found_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Not_Found_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_not_found_body(inputs)
	return cs_error_not_found_body(inputs)
});